import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCardActions,[_c('FileForm',{ref:"docForm",attrs:{"mimeTypes":_vm.mimeTypes,"files":[],"idx":_vm.fileKey}}),_c(VBtn,{attrs:{"color":_vm.color,"left":"","outlined":"","icon":_vm.icon,"small":_vm.small,"rounded":_vm.rounded,"disabled":_vm.disabled},on:{"click":function($event){return _vm.onPickFile({
      loadedEvent: _vm.loadedEvent,
      deleteEvent: _vm.deletedEvent,
      key: _vm.fileKey}
    )}}},[(_vm.icon)?_c(VIcon,[_vm._v("\n      mdi-plus\n    ")]):_c('span',[_vm._v("      "+_vm._s(_vm.icon ? undefined : _vm.label))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }